import { TaxonomyTags } from "./TaxonomyTags.component";
import { TAXONOMY_DEPTH } from "./TaxonomyTags.constants";
import {
  TaxonomyTagsProvider,
  useTaxonomyTagsContext,
} from "./TaxonomyTags.provider";
import {
  ITaxonomyApiResponse,
  ITaxonomyApiResponseContent,
  ITaxonomyTags,
} from "./TaxonomyTags.types";

export {
  TaxonomyTags,
  TaxonomyTagsProvider,
  useTaxonomyTagsContext,
  TAXONOMY_DEPTH,
};

export type {
  ITaxonomyApiResponse,
  ITaxonomyApiResponseContent,
  ITaxonomyTags,
};
